export default __webpack_public_path__ + "static/media/logo.979b4d65.jpeg";